/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { TextField, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import GenericModal from "../../Modal/GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/urlEnum";
import style from "../../Styles/progressAction.module.css";
import moment from "moment";

type VehicleModel = {
  id: number;
  vin: string;
  brand_r?: { nume: string };
  model_r?: { nume: string };
  status_vehicul_r?: { nume: string };
  vehicule_files_r?: Array<{ file: string }>;
  deactivated_at?: string | null;
};

type VehicleSearchModalProps = {
  open: boolean;
  onClose: () => void;
  onSelectVehicle: (vehicle: VehicleModel) => void;
};

const MIN_SEARCH_LEN = 3;

export default function VehicleSearchModal({
  open,
  onClose,
  onSelectVehicle,
}: VehicleSearchModalProps) {
  const [vehicleName, setVehicleName] = useState("");
  const [searchResult, setSearchResult] = useState<VehicleModel[] | null>(null);

  const handleSearchVehicle = (event: any) => {
    const { value } = event.target;
    setVehicleName(value);
    if (value && value.length > MIN_SEARCH_LEN) {
      // fetch search data
      postData(`${urlEnum.searchVehicles}`, { search: value }).then(
        (response: any) => {
          setSearchResult(response.data);
        }
      );
    }
  };

  const handleClose = () => {
    setVehicleName("");
    setSearchResult(null);
    onClose();
  };

  const handleSelectVehicle = (vehicle: VehicleModel) => {
    onSelectVehicle(vehicle);
    handleClose();
  };

  return (
    <GenericModal
      open={open}
      onClose={handleClose}
      title=""
    >
      <div style={{ textAlign: "center" }}>
        <TextField
          autoFocus
          name="vehicleName"
          variant="standard"
          label={Vocabulary.associateWithVehicle}
          value={vehicleName ? vehicleName : ""}
          onChange={(event) => {
            handleSearchVehicle(event);
          }}
          style={{ margin: 10, width: "90%" }}
        />
      </div>
      <div className={style.searchWrapper}>
        <h3 style={{ fontWeight: 100 }}>{Vocabulary.searchResult}</h3>
      </div>
      <Divider />
      {searchResult && (
        <div
          className={style.searchWrapper}
          style={{ maxHeight: "700px", overflowY: "scroll" }}
        >
          <List sx={{ width: "90%", bgcolor: "background.paper" }}>
            {searchResult.map((vehicle: VehicleModel, index: number) => (
              <ListItem
                alignItems="flex-start"
                key={index}
                className={style.searchListItem}
                style={{ cursor: "pointer" }}
                onClick={() => handleSelectVehicle(vehicle)}
              >
                <ListItemAvatar
                  style={{ margin: "0px 20px 0px 0px", width: 76 }}
                >
                  {vehicle.vehicule_files_r?.length ? (
                    <div
                      className={style.iconWrapper}
                      style={{
                        backgroundImage: `url("/api/${vehicle.vehicule_files_r[0].file}")`,
                      }}
                    ></div>
                  ) : (
                    <div className={style.iconWrapper}>
                      <DirectionsCarIcon />
                    </div>
                  )}
                </ListItemAvatar>
                <ListItemText
                  primary={`${vehicle?.brand_r?.nume} ${vehicle?.model_r?.nume}`}
                  secondary={
                    <>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        VIN: {vehicle.vin.toUpperCase()}
                      </Typography>
                      <br />
                      {Vocabulary.status}: {vehicle?.status_vehicul_r?.nume}
                      {vehicle?.deactivated_at && (
                        <>
                          <br />
                          <Typography
                            sx={{
                              display: "inline",
                              fontSize: "0.875rem",
                              color: "#ff6b6b",
                              fontWeight: 600,
                            }}
                          >
                            {Vocabulary.deactivatedOn}{" "}
                            {moment(vehicle.deactivated_at).format("DD-MM-YYYY")}
                          </Typography>
                        </>
                      )}
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        </div>
      )}
    </GenericModal>
  );
}